import { SharedConfig as Config } from "./types";

let globalConfig: Config | null = null;

export function setSharedConfig(config: Config) {
  globalConfig = config;
}

function getConfig(): Config {
  if (!globalConfig) {
    return {
      appUrl: process.env.APP_URL,
      siapkerjaAppUrl: process.env.SIAPKERJA_APP_URL,
      consoleAppUrl: process.env.CONSOLE_APP_URL,
      employerAppUrl: process.env.EMPLOYER_APP_URL,
      apiUrl: process.env.API_URL || "https://api.kemnaker.go.id",
      faviconUrl: `/favicon.ico`,
      googleTagManagerId: process.env.GOOGLE_TAG_MANAGER_ID,
      googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
      stand: process.env.STAND,
      algolia: {
        applicationId: process.env.ALGOLIA_APPLICATION_ID,
        searchApiKey: process.env.ALGOLIA_SEARCH_API_KEY,
      },
      cmsUrl: process.env.CMS_URL,
      cmsToken: process.env.CMS_TOKEN,
      naco: {
        clientId: process.env.NACO_CLIENT_ID || "",
        clientSecret: process.env.NACO_CLIENT_SECRET || "",
      },
      wlkpAppUrl: process.env.WLKP_APP_URL || "",
    };
  }
  return globalConfig as Config;
}

export function createSharedConfigService(): { config: Config } {
  const config = getConfig();

  return {
    config,
  }
}